import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagIN = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "M25 0C15.09 0 6.525 5.768 2.481 14.13H47.52C43.476 5.768 34.912 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M25 50c9.912 0 18.476-5.769 22.52-14.131H2.48c4.044 8.362 12.608 14.13 22.52 14.13Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 33.696a8.696 8.696 0 1 0 0-17.392 8.696 8.696 0 0 0 0 17.392Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 30.434a5.435 5.435 0 1 0 0-10.869 5.435 5.435 0 0 0 0 10.87Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "m25 18.293 1.677 3.803 4.131-.45L28.354 25l2.454 3.353-4.131-.45L25 31.707l-1.676-3.802-4.132.449L21.647 25l-2.455-3.354 4.132.45L25 18.293Z"
}));
FlagIN.displayName = 'FlagIN';
export default withFlagWrapper(FlagIN);
//# sourceMappingURL=index.js.map